<template>
    <div :key="key">
        <b-input
            ref="entry_date"
            v-model="form.entry_date"
            size="sm"
            :class="reactiveClass"
            @change="savePoint"
        />
    </div>
</template>

<script>
import TableFormHandler from '../../../../../common/mixins/TableFormHandler'

export default {
    name: 'EntryDateForm',

    mixins: [TableFormHandler],

    props: {
        point: {},
    },

    methods: {
        async savePoint() {
            try {
                await axios.put(
                    `/pendingPoints/${this.point.id}/entry-date`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.entry_date = this.$moment(this.point.entry_date).format(
                'D/M/Y'
            )
        },

        setInitialKey() {
            this.key = `entry_date${this.point.id}`
        },

        unFocus() {
            this.$refs.entry_date.blur()
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
